import axios, { CancelTokenSource } from 'axios';
import { isUndefined } from 'lodash';

export interface PollingManagerProps {
  onPoll: (isFirstPoll: boolean, cancelToken: CancelTokenSource) => void;
  pollingInterval: number;
  shouldPollOnStart?: boolean;
}

export class PollingManager {
  private pollingInterval: number;
  private onPoll: (isFirstPoll: boolean, cancelToken: CancelTokenSource) => void;
  private intervalId: NodeJS.Timeout | undefined;
  private shouldPollOnStart: boolean;
  private isFirstPoll: boolean = true;
  private cancelToken: CancelTokenSource;

  constructor(args: PollingManagerProps) {
    const { pollingInterval, shouldPollOnStart = true, onPoll } = args;
    this.pollingInterval = pollingInterval;
    this.shouldPollOnStart = shouldPollOnStart;
    this.onPoll = onPoll;
    this.cancelToken = axios.CancelToken.source();
  }

  public readonly startPolling = () => {
    if (!isUndefined(this.intervalId)) {
      console.warn('Polling already in progress');
      return;
    }
    if (this.shouldPollOnStart) {
      this.onPoll(this.isFirstPoll, this.cancelToken);
      this.isFirstPoll = false;
    }
    this.intervalId = setInterval(() => {
      this.onPoll(this.isFirstPoll, this.cancelToken);
      this.isFirstPoll = false;
    }, this.pollingInterval);
  };

  public readonly stopPolling = () => {
    if (!isUndefined(this.intervalId)) {
      console.warn('Stopping poller...');
      this.cancelToken.cancel();
      clearInterval(this.intervalId);
      // Reset the intervalId and cancelToken
      this.intervalId = undefined;
      this.cancelToken = axios.CancelToken.source();
    }
  };

  public readonly isPolling = () => !isUndefined(this.intervalId);
}
